import $ from 'jquery';

export const init = () => {

	// hide items into responsive menu
	$('.m-responsive').each(function () {
		let $menuResponsive = $(this);
		let	$menuResponsiveItems = $menuResponsive.find('.m-responsive__item');
		let	$closest = $menuResponsive.closest('.header__menu');
		let	$wrap = $closest.find('.header__menu-wrap');
		let	$menuMain = $closest.find('.m-main');
		let	$menuMainItems = $menuMain.find('.m-main__item');

		$(window).on('resize.menuMain', function () {
			//console.log('resize');
			$wrap.removeClass('is-visible');
			$menuMainItems.removeClass('is-invisible');
			$menuResponsiveItems.removeClass('is-visible');
			$menuResponsive.removeClass('is-visible');

			if ($wrap.width() < $menuMain.width()) {
				$menuResponsive.addClass('is-visible');
			}

			$menuMainItems.not('.m-main__item-fake').each(function () {
				let $that = $(this);
				if (($that.position().left + $that.width()) > ($wrap.width() - $menuResponsive.filter(':visible').width())) {
					$that.addClass('is-invisible');
					$menuResponsiveItems.eq($that.index()).addClass('is-visible');
				}
			});


			$wrap.addClass('is-visible');
		});
	});

	// hide items in .m-all menu
	// $('.m-all').each(function () {
	// 	var $this = $(this),
	// 		$closest = $this.closest('.header__menu'),
	// 		$wrap = $closest.find('.header__menu-wrap'),
	// 		$menuMain = $closest.find('.m-main'),
	// 		$menuMainItems = $menuMain.find('.m-main__item');

	// 	$(window).on('resize.menuAll', function () {
	// 		$wrap.removeClass('is-visible');
	// 		$menuMainItems.removeClass('is-invisible');

	// 		$menuMainItems.each(function () {
	// 			var $that = $(this);
	// 			if (($that.position().left + $that.width()) > $wrap.width()) {
	// 				$that.addClass('is-invisible');
	// 			}
	// 		});

	// 		$wrap.addClass('is-visible');
	// 	});
	// });

	// submenu width fix
	$('.m-submenu--full:not(.m-submenu--side)').each( function() {
		let $this = $(this),
			$closest = $this.closest('.row-main');


		$(window).on('resize.menuSide', function () {
			$this.css('margin-left', 0);
			$this.css('margin-left', ($closest.offset().left - $this.offset().left + Number($closest.css('paddingLeft').split('px')[0])));
		});
	});

	// delegate
	$(document)
		// all categories
		.on('click', '.m-main__item--all .m-main__link', function (e) {
			e.preventDefault();

			let $this = $(this),
				$closest = $this.closest('.m-main__item--all');

			$closest.toggleClass('is-open');
		})
		// responsive menu
		.on('click', '.m-responsive__title', function (e) {
			e.preventDefault();

			let $this = $(this),
				$closest = $this.closest('.m-responsive');

			$closest.toggleClass('is-open');

			$("html").css({
				//overflow: 'hidden',
				//height: '100%',
				//'scrollbar-gutter': 'stable'
			});

      $("html").addClass("show-menu");

		})
		// touch click
		.on('click', '.m-main__item:not(.m-main__item--all) .m-main__link:not(.is-clickable), .m-all__link:not(.is-clickable)', function (e) {
			if ($('html').hasClass('touchevents')) {
				let $this = $(this),
					$closest = $this.parent(),
					$submenu = $closest.find('.m-submenu');

				if ($submenu.length) {
					e.preventDefault();
					$this.addClass('is-clickable');
					$closest.addClass('is-hover');
				}
			}
		})
		.on('click', '.m-responsive__popup-close', function (e) {
			$('.m-responsive').removeClass('is-open');
			$("html").css({
				//overflow: 'auto',
				//height: 'auto'
			});
      $("html").removeClass("show-menu");
		})
		// out click
		.on('click', function (e) {

			if (!$(e.target).closest('.m-main__item--all').length) {
				$('.m-main__item--all').removeClass('is-open');
			}
			if (!$(e.target).closest('.m-responsive').length) {
				$('.m-responsive').removeClass('is-open');
			}

			// touch reset
			$('.m-main__item').not($(e.target).closest('.m-main__item.is-hover')).removeClass('is-hover')
				.find('.m-main__link').removeClass('is-clickable');
			$('.m-all__item').not($(e.target).closest('.m-all__item.is-hover')).removeClass('is-hover')
				.find('.m-all__link').removeClass('is-clickable');

		});

	// triggers
	$(window).trigger('resize.menuMain');
	$(window).trigger('resize.menuSide');
	// $(window).trigger('resize.menuAll');
};
